/**
 * Application Routes
 * Centralized route definitions for the application
 */

export const ROUTES = {
  LOOT_SPLIT: '/loot-split',
  SOLO_HUNT: '/solo-hunt',
  IMBUEMENT_CALC: '/imbuement-calc',
  BESTIARY_PLANNER: '/bestiary-planner',
  CHARACTER_SET_BUILDER: '/character-set-builder',
  WHEEL_PLANNER: '/wheel-planner',
};

/**
 * Default route (homepage)
 */
export const DEFAULT_ROUTE = ROUTES.LOOT_SPLIT;
